<script lang="ts" setup>
import type { PropType } from 'vue'
import BsButtonOutline from '@/legacy/components/ButtonOutline.vue'
import { getProductSharingUrl } from '@/legacy/ts/productSharing'

defineProps({
	text: {
		type: Object as PropType<any>,
		required: true,
	},
})

function toExplore() {
	window.location.href = getProductSharingUrl('recommended')
}
</script>

<template>
	<div class="bs-product-sharing-empty-content">
		<div class="bs-product-sharing-empty-content__icon__wrap">
			<div class="bs-product-sharing-empty-content__icon">
				<i class="bs-icon bs-icon--post-not-allow"></i>
			</div>
		</div>
		<div class="bs-product-sharing-empty-content__content">
			{{ text.empty }}
		</div>
		<div class="bs-product-sharing-empty-content__button">
			<BsButtonOutline :action="toExplore" :text="text?.button.explore">
				<template #leading>
					<i class="bs-icon--explore"></i>
				</template>
			</BsButtonOutline>
		</div>
	</div>
</template>
